if (!customElements.get('show-more-button-mobile')) {
  customElements.define(
    'show-more-button-mobile',
    class ShowMoreButtonMobile extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('.button-show-more');
        button.addEventListener('click', (event) => {
          console.log('the clique');
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentWrap = this.closest('.mobile-facets__submenu').querySelector('ul');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentWrap.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}